import { AlertTriangleIcon, ExternalLinkIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/button";
import { ConfirmationModal } from "@/components/confirmation-modal";

import {
  useDisconnectGoogleOAuth,
  useGoogleDriveStatus,
  useInitiateGoogleOAuth,
} from "../hooks/useGoogleDriveOAuth";

export function GDriveSyncButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading } = useGoogleDriveStatus();
  const { isPending: initiating, mutateAsync: initiate } =
    useInitiateGoogleOAuth();
  const { isPending: disconnecting, mutateAsync: disconnect } =
    useDisconnectGoogleOAuth();

  if (isLoading) return null;
  const connected = Boolean(data?.connected);

  const handleConnect = async () => {
    try {
      const { url } = await initiate();

      window.location.href = url;
    } catch (error) {
      console.error(error);
    }
  };

  const handleDisconnectClick = () => {
    setIsModalOpen(true);
  };

  const handleConfirmDisconnect = async () => {
    await disconnect();
    setIsModalOpen(false);
  };

  return (
    <>
      {connected ? (
        <div className="flex items-center gap-md">
          <Button
            color="gray"
            isDisabled={disconnecting}
            onPress={handleDisconnectClick}
            variant="tertiary"
          >
            Disconnect your Google Drive
          </Button>
          <Button variant="primary">
            <span className="inline-block h-2 w-2 rounded-full bg-green-500 mr-2" />
            Google Drive sync
          </Button>
        </div>
      ) : (
        <Button isDisabled={initiating} onPress={handleConnect}>
          Sync to your Google Drive
          <ExternalLinkIcon className="ml-sm h-4 w-4" />
        </Button>
      )}

      <ConfirmationModal
        cancelButtonText="Keep connected"
        confirmButtonColor="destructive"
        confirmButtonText="Disconnect anyway"
        icon={
          <AlertTriangleIcon className="text-featured-icon-light-fg-error" />
        }
        isConfirmLoading={disconnecting}
        isOpen={isModalOpen}
        onConfirm={handleConfirmDisconnect}
        onOpenChange={setIsModalOpen}
        title="Wait!"
      >
        <p className="text-sm text-text-tertiary font-semibold">
          Your files are still uploading. Disconnecting now will interrupt the
          process.
        </p>
      </ConfirmationModal>
    </>
  );
}
